import {
  Alert,
  AlertTitle,
  Slide,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbars } from "../../store/snackbars/hooks";

export const StoiFailureSnackbar = () => {
  const {
    stoiFailedResponse,
    showStoiFailedSnackbar,
    clearStoiFailedResponse,
    closeStoiFailedSnackbar,
  } = useSnackbars();

  const { reason, description } = stoiFailedResponse || {};

  const handleClose = () => closeStoiFailedSnackbar();
  const handleExited = () => clearStoiFailedResponse();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={showStoiFailedSnackbar}
      autoHideDuration={7500}
      onClose={handleClose}
      slots={{
        transition: Slide,
      }}
      slotProps={{
        transition: {
          direction: "up",
          onExited: handleExited,
        },
      }}
    >
      <Alert
        onClose={handleClose}
        severity="error"
        variant="filled"
        sx={{
          boxShadow: 3,
          width: 540,
        }}
      >
        <AlertTitle>STOI calculation failed</AlertTitle>
        <Stack spacing={0.5}>
          <Typography variant="body2">{reason}</Typography>
          <Typography variant="body2">
            Please view <strong>{description}</strong> clip history for more
            information.
          </Typography>
        </Stack>
      </Alert>
    </Snackbar>
  );
};
